export class Evented<T extends string> {
    protected handlers: Map<T, Array<(...args: any[]) => void>> = new Map();

    on(event: T, handler: (...args: any[]) => void) {
        let handlers = this.handlers.get(event);
        if (!handlers) {
            handlers = [];
            this.handlers.set(event, handlers);
        }
        handlers.push(handler);

        return () => {
            const eventHandler = this.handlers.get(event);
            if (eventHandler) {
                eventHandler.splice(eventHandler.indexOf(handler), 1);
            }
        };
    }

    clearHandlers() {
        this.handlers.clear();
    }

    protected fire(event: T, ...args: any[]) {
        const handlers = this.handlers.get(event);
        if (handlers) {
            handlers.forEach(handler => {
                handler(...args);
            });
        }
    }
}
